import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import { Pagination, Navigation } from "swiper/modules";

class PopularCars extends React.Component {
  render() {
    // customize swiper navigations
    const sliderRef = React.createRef(null);

    return (
      <div className={` ${"popularCars"}`}>
        <div className={"title"}>
          <span> خودرو های پرطرفدار</span>
          <Link
            to="/PopularCarsItems"
            passHref
            className={`${"popularShowAll"}`}
          >
            <div className={"link"}>
              <a>مشاهده همه</a>
              <a className="icon-chevron-left"></a>
            </div>
          </Link>
        </div>
        <div className={"main"}>
          <Swiper
            className={`${"popularCarsSlider"}`}
            ref={sliderRef}
            spaceBetween={5}
            slidesPerView={4}
            modules={[Pagination, Navigation]}
            breakpoints={{
              300: { slidesPerView: 1 },
              360: { slidesPerView: 1.2 },
              400: { slidesPerView: 1.5 },
              500: { slidesPerView: 2.5 },
              640: { slidesPerView: 3.2 },
              840: { slidesPerView: 3.5 },
              1007: { slidesPerView: 3.8 },
              1200: { slidesPerView: 3 },
              1366: { slidesPerView: 4 },
              1920: { slidesPerView: 5 },
            }}
            navigation={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
          >
            {this.props.data.map((car) => (
              <SwiperSlide key={car.id}>
                <div className={"car"}>
                  <Link
                    href={`/popular-cars/${car.car_brand}/${car.slug}/${car.id}?category=3`}
                    passHref
                  >
                    <a>
                      <img src={car.image} alt={car.car_name} />
                      <span className={"name"}>{car.car_name}</span>
                    </a>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    );
  }
}
export default PopularCars;
